export const SET_SELECTED_TEMPLATE = 'CARD_LINK/SET_SELECTED_TEMPLATE'
export const SET_SELECTED_CARDS = 'CARD_LINK/SET_SELECTED_CARDS'
